<template>
  <div class="thirdPage">
    <div class="page">
      <div class="leftBlog">
        <router-link
          :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
          class="leftsec"
          v-for="(item, index) in list.slice(0, 3)"
          :key="index"
        >
          <ImageContainer
            :src="item.image.medium"
            :thumb="item.image.thumbnail"
            :alt="item.title"
            class="img"
          />
          <h2>{{ item.sub_category.name }}</h2>
          <h1>{{ item.title }}</h1>
          <h3>
            {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
          </h3>
        </router-link>
      </div>
      <div class="midBlog">
        <router-link
          :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
          class="midsec"
          v-for="(item, index) in list.slice(3, 5)"
          :key="index"
        >
          <ImageContainer
            :src="item.image.medium"
            :thumb="item.image.thumbnail"
            :alt="item.title"
            class="img"
          />
          <h2>{{ item.sub_category.name }}</h2>
          <h3>
            {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
          </h3>
          <h1>{{ item.title }}</h1>
          <div class="border" v-if="!isIpad"></div>
          <p v-if="!isIpad">{{ item.brief }}</p>
        </router-link>
      </div>
      <div class="rightBlog">
        <router-link
          :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
          class="rightsec"
          v-for="(item, index) in list.slice(5, 8)"
          :key="index"
        >
          <ImageContainer
            :src="item.image.medium"
            :thumb="item.image.thumbnail"
            :alt="item.title"
            class="img"
          />
          <h2>{{ item.sub_category.name }}</h2>
          <h1>{{ item.title }}</h1>
          <h3>
            {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
          </h3>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeUnmount } from "vue";
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const isIpad = ref();
    const isMobile = ref();

    const handleResize = () => {
      isIpad.value = window.innerWidth <= 1366;
      isMobile.value = window.innerWidth <= 1366;
    };

    if (typeof window !== "undefined") {
      isIpad.value = window.innerWidth <= 1366;
      isMobile.value = window.innerWidth <= 1366;
      window.addEventListener("resize", handleResize);
    }

    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    });
    return { isIpad, handleResize, isMobile, ...useFormatter() };
  },
};
</script>

<style lang="scss" scoped>
.thirdPage {
  background: var(--second-bg);
  font-family: "Montserrat", sans-serif;
  padding-top: 4.167vw;
  padding-bottom: 4.167vw;
  padding-left: 4.688vw;
  padding-right: 4.688vw;
  p {
    display: block; /* Fallback for non-webkit */
    display: -webkit-box;
    -webkit-line-clamp: 6; /* if you change this, make sure to change the fallback line-height and height */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .page {
    display: grid;
    grid-template-areas: "left mid right";
    .leftBlog {
      grid-area: left;
      .leftsec {
        width: 27.708vw;
        height: 17vw;
        position: relative;
        cursor: pointer;
        background: black;
        display: flex;
        justify-content: center;
        .img {
          width: 27.708vw;
          height: 17vw;
          opacity: 0.5;
        }
        h2 {
          position: absolute;
          top: 0;
          left: 0;
          font-size: 0.729vw;
          font-weight: 700;
          width: 5.688vw;
          height: 1.2vw;
          background: var(--black);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        h1 {
          font-size: 1.302vw;
          line-height: 1.4vw;
          font-weight: 900;
          text-align: center;
          position: absolute;
          bottom: 1.458vw;
          width: 23.542vw;
          pointer-events: none;
        }
        h3 {
          font-size: 0.625vw;
          line-height: 0.781vw;
          font-weight: 700;
          color: var(--date);
          text-align: center;
          position: absolute;
          bottom: 0.521vw;
          left: 50%;
          transform: translateX(-50%);
          pointer-events: none;
        }
      }
    }
    .midBlog {
      grid-area: mid;
      .midsec {
        width: 25.833vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        align-items: center;
        cursor: pointer;
        h2 {
          font-size: 0.729vw;
          line-height: 0.885vw;
          font-weight: 700;
          padding: 0.1vw;
          background: var(--grey-six);
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 0.156vw;
        }
        h3 {
          font-size: 0.625vw;
          line-height: 0.781vw;
          font-weight: 700;
          color: var(--date-grey);
          margin-top: 0.26vw;
        }
        h1 {
          font-size: 1.579vw;
          line-height: 2.169vw;
          font-weight: 900;
          color: var(--title-black);
        }
        p {
          font-size: 1.046vw;
          line-height: 1.406vw;
          font-weight: 700;
          color: var(--p-black);
        }
        .border {
          width: 9.792vw;
          height: 0.104vw;
          background: var(--black);
          margin-left: auto;
          margin-right: auto;
          margin-top: 0.625vw;
          margin-bottom: 0.417vw;
        }
        &:nth-child(2) {
          margin-top: 4vw;
        }
      }
    }
    .rightBlog {
      grid-area: right;
      .rightsec {
        width: 27.708vw;
        height: 17vw;
        position: relative;
        cursor: pointer;
        background: black;
        display: flex;
        justify-content: center;
        .img {
          width: 27.708vw;
          height: 17vw;
          opacity: 0.5;
        }
        h2 {
          position: absolute;
          top: 0;
          right: 0;
          font-size: 0.729vw;
          line-height: 0.885vw;
          font-weight: 700;
          width: 5.688vw;
          height: 1.2vw;
          background: var(--black);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        h1 {
          font-size: 1.202vw;
          line-height: 1.4vw;
          font-weight: 900;
          text-align: center;
          position: absolute;
          bottom: 1.458vw;
          width: 23.542vw;
        }
        h3 {
          font-size: 0.625vw;
          line-height: 0.781vw;
          font-weight: 700;
          color: var(--date);
          text-align: center;
          position: absolute;
          bottom: 0.521vw;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .thirdPage {
    padding-bottom: 7.161vw;
    .page {
      display: grid;
      grid-template-areas:
        "left right"
        "mid mid";
      .leftBlog {
        .leftsec {
          width: 40.755vw;
          height: 45.833vw;
          position: relative;
          margin-top: 7.161vw;
          background: transparent;
          color: var(--black);
          display: grid;
          grid-template-areas:
            "pageCategory"
            "pageTitle"
            "pageImg"
            "publishedDate";
          .img {
            width: 40.755vw;
            height: 30.729vw;
            opacity: 1;
            grid-area: pageImg;
          }
          h2 {
            display: block;
            width: max-content;
            height: max-content;
            margin-bottom: 0.391vw;
            position: relative;
            grid-area: pageCategory;
            background: transparent;
            font-size: 1.693vw;
            line-height: 2.344vw;
            bottom: 0;
            color: var(--black-seven);
          }
          h3 {
            position: relative;
            grid-area: publishedDate;
            font-size: 1.693vw;
            line-height: 2.344vw;
            display: flex;
            justify-content: flex-start;
            margin-top: 0.781vw;
            color: var(--black);
            font-weight: 300;
          }
          h1 {
            position: relative;
            font-size: 2.083vw;
            line-height: 2.865vw;
            font-weight: 600;
            text-align: left;
            grid-area: pageTitle;
            bottom: 0;
            margin-bottom: 0.651vw;
            width: 100%;
          }
        }
      }
      .midBlog {
        display: flex;
        justify-content: space-between;
        align-items: center;

        margin-top: 7.161vw;
        .midsec {
          width: 40.755vw;
          height: 45.833vw;
          position: relative;
          background: transparent;
          color: var(--black);
          display: grid;
          grid-template-areas:
            "pageCategory"
            "pageTitle"
            "pageImg"
            "publishedDate";
          .img {
            width: 40.755vw;
            height: 30.729vw;
            opacity: 1;
            grid-area: pageImg;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          h2 {
            display: block;
            width: max-content;
            height: max-content;
            margin-bottom: 0.391vw;
            position: relative;
            grid-area: pageCategory;
            background: transparent;
            font-size: 1.693vw;
            line-height: 2.344vw;
            bottom: 0;
            color: var(--black-seven);
          }
          h3 {
            position: relative;
            grid-area: publishedDate;
            font-size: 1.693vw;
            line-height: 2.344vw;
            display: flex;
            justify-content: flex-start;
            margin-top: 0.781vw;
            color: var(-black);
            font-weight: 300;
          }
          h1 {
            position: relative;
            font-size: 2.083vw;
            line-height: 2.865vw;
            font-weight: 600;
            text-align: left;
            grid-area: pageTitle;
            bottom: 0;
            margin-bottom: 0.651vw;
            width: 100%;
          }
          &:nth-child(2) {
            margin-top: 0;
          }
        }
      }
      .rightBlog {
        .rightsec {
          width: 40.755vw;
          height: 45.833vw;
          position: relative;
          margin-top: 7.161vw;
          background: transparent;
          color: var(--black);
          display: grid;
          grid-template-areas:
            "pageCategory"
            "pageTitle"
            "pageImg"
            "publishedDate";
          .img {
            width: 40.755vw;
            height: 30.729vw;
            opacity: 1;
            grid-area: pageImg;
          }
          h2 {
            display: block;
            width: max-content;
            height: max-content;
            margin-bottom: 0.391vw;
            position: relative;
            grid-area: pageCategory;
            background: transparent;
            font-size: 1.693vw;
            line-height: 2.344vw;
            bottom: 0;
            color: var(--black-seven);
          }
          h3 {
            position: relative;
            grid-area: publishedDate;
            font-size: 1.693vw;
            line-height: 2.344vw;
            display: flex;
            justify-content: flex-start;
            margin-top: 0.781vw;
            color: var(--black);
            font-weight: 300;
          }
          h1 {
            position: relative;
            font-size: 2.083vw;
            line-height: 2.865vw;
            font-weight: 600;
            text-align: left;
            grid-area: pageTitle;
            bottom: 0;
            margin-bottom: 0.651vw;
            width: 100%;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 414px) {
  .thirdPage {
    width: 100vw;
    margin: 0;
    padding-right: 0;
    padding-top: 8.454vw;
    .page {
      display: grid;
      grid-template-areas:
        "left right"
        "mid right";
      .leftBlog {
        .leftsec {
          width: 40.338vw;
          height: 25.43vw;
          .img {
            display: none;
          }
          h2 {
            font-size: 2.415vw;
            line-height: 3.382vw;
            width: max-content;
            left: 0;
            color: var(--black-seven);
          }
          h1 {
            font-size: 3.2vw;
            line-height: 4vw;
            margin: 0;
          }
          h3 {
            font-size: 2.415vw;
            line-height: 3.382vw;
            font-weight: 300;
            color: var(--black-six);
          }
          &:nth-child(2),
          &:nth-child(3) {
            margin-top: 12.493vw;
          }
        }
      }
      .midBlog {
        display: grid;
        grid-template-columns: auto;
        padding-bottom: 15vw;
        .midsec {
          width: 40.338vw;
          height: 23.43vw;
          text-align: left;
          position: relative;
          .img {
            display: none;
          }
          h2 {
            font-size: 2.415vw;
            line-height: 3.382vw;
            color: var(--black-seven);
          }
          h1 {
            font-size: 2.899vw;
            line-height: 3.623vw;
          }
          h3 {
            font-size: 2.415vw;
            line-height: 3.382vw;
          }

          &:nth-child(2) {
            margin-top: 14vw;
          }
        }
      }
      .rightBlog {
        display: flex;
        flex-direction: column;
        width: 45.411vw;
        margin-left: 9vw;
        gap: 10vw;
        .rightsec {
          display: grid;
          grid-template-areas:
            "category"
            "title"
            "img"
            "date";
          width: 45.411vw;
          // background: var(--light);
          gap: 1vw;
          .img {
            width: 45.411vw;
            grid-area: img;
          }
          h2 {
            grid-area: category;
            font-size: 2.415vw;
            line-height: 3.382vw;
            width: 100%;
            color: var(--black-seven);
            background: var(--second-bg);
          }
          h1 {
            grid-area: title;
            font-size: 2.415vw;
            line-height: 3.382vw;
            padding: 1.208vw;
            background: var(--light);
            width: 45.411vw;
          }
          h3 {
            grid-area: date;
            font-size: 2.415vw;
            line-height: 3.382vw;
            font-weight: 300;
            color: var(--black-six);
            position: relative;
            background: var(--second-bg);
          }
        }
      }
    }
  }
}
</style>